import dynamic, { DynamicOptions } from 'next/dynamic'
import { logger } from '@/utils/logging'
import { GuildPromotionCountdownProps } from './GuildPromotionCountdown'
import { GuildPromotionCountdownSimplifiedProps } from './GuildPromotionCountdownSimplified'

export const GuildPromotionCountdown = dynamic(
  import('./GuildPromotionCountdown')
    .then((mod) => mod.GuildPromotionCountdown)
    .catch((err) =>
      logger().error('Failed to load dynamic component', { component: 'GuildPromotionCountdown' }, err),
    ) as DynamicOptions<GuildPromotionCountdownProps>,
  { ssr: false },
)

export const GuildPromotionCountdownSimplified = dynamic(
  import('./GuildPromotionCountdownSimplified')
    .then((mod) => mod.GuildPromotionCountdownSimplified)
    .catch((err) =>
      logger().error('Failed to load dynamic component', { component: 'GuildPromotionCountdownSimplified' }, err),
    ) as DynamicOptions<GuildPromotionCountdownSimplifiedProps>,
  { ssr: false },
)
